import React, { useEffect, useRef } from 'react';
import Litepicker from 'litepicker';
import { useBooking } from '../context/booking';
import moment from 'moment';

const LitePicker = ({onSelect}) => {
  const { booking, openDays, getAvailableTimeSlots } = useBooking();
  const pickerRef = useRef(null);
  const litepickerRef = useRef(null); // Ref to store the Litepicker instance

  useEffect(() => {
    // Destroy the previous instance if it exists
    if (litepickerRef.current) {
      litepickerRef.current.destroy();
    }

    // Only unlock days that have a valid opening window (end after start)
    const validOpenDays = (openDays || []).filter(d =>
      d?.start_time && d?.end_time && moment(d.end_time).isAfter(moment(d.start_time))
    );
    const unlockedDates = validOpenDays.map(d => moment(d.start_time).format('YYYY-MM-DD'));

    // Create a new instance of Litepicker
    litepickerRef.current = new Litepicker({ 
      element: pickerRef.current,
      inlineMode: true,
      singleMode: true,
      
      lockDaysFilter: (date) => {
          const formattedDate = date.format('YYYY-MM-DD');
          return !unlockedDates.includes(formattedDate);
        },
        highlightedDays: validOpenDays.map(d => moment(d?.start_time).toDate()),
  
      setup: (picker) => {
        picker.on('selected', (date1, date2) => {
         onSelect(date1)
         getAvailableTimeSlots(date1);
        });
      },
    });

    // Cleanup function to destroy Litepicker instance when component unmounts
    return () => {
      if (litepickerRef.current) {
        litepickerRef.current.destroy();
      }
    };
  }, [booking?.booking_dates, booking?.disabled_dates, openDays, onSelect, getAvailableTimeSlots]);

  return (
    <input 
      type="text" 
      ref={pickerRef} 
      style={{ display: 'none' }} 
      name="Booking Date" 
      disabled='disabled'
    />
  );
};

export default LitePicker;
